<template>
  <div id="dashboard">
    <CRow>
      <CCol col="12">
        <CCard>
          <!-- Header -->
          <CCardHeader
            v-if="user"
          >
            <h4 class="mb-0">
              Bem vindo(a), {{ user.name }}
            </h4>
          </CCardHeader>

          <!-- Body -->
          <CCardBody>
            <!-- Cards -->
            <CRow>
              <div
                v-if="cards"
                class="cards-container"
              >
                <CCol
                  v-for="(card, index) in cards"
                  :key="index"
                  md="4"
                >
                  <CardInfo
                    :info="card"
                    :color="card.color"
                    class="mb-2 mb-md-0"
                  />
                </CCol>
              </div>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol
        v-if="charts.products && charts.products.length > 0"
        lg="6"
      >
        <CCard>
          <!-- Header -->
          <CCardHeader>
            <h5 class="mb-0">
              Produtos mais acessados<br /> <small class="text-muted">Passe sobre o gráfico para visualizar mais informações</small>
            </h5>
          </CCardHeader>

          <!-- Body -->
          <CCardBody class="pl-0">
            <AccessChart
              id="chart-products"
              color="#7956e8"
              :data="charts.products"
            />
          </CCardBody>
        </CCard>
      </CCol>

      <CCol
        v-if="charts.applications && charts.applications.length > 0"
        lg="6"
      >
        <CCard>
          <!-- Header -->
          <CCardHeader>
            <h5 class="mb-0">
              Aplicações mais acessadas<br /> <small class="text-muted">Passe sobre o gráfico para visualizar mais informações</small>
            </h5>
          </CCardHeader>

          <!-- Body -->
          <CCardBody class="pl-0">
            <AccessChart
              id="chart-applications"
              color="#0f96e7"
              :data="charts.applications"
            />
          </CCardBody>
        </CCard>
      </CCol>

      <CCol
        v-if="charts.publications && charts.publications.length > 0"
        col="12"
      >
        <CCard>
          <!-- Header -->
          <CCardHeader>
            <h5 class="mb-0">
              Publicações mais acessadas<br /> <small class="text-muted">Passe sobre o gráfico para visualizar mais informações</small>
            </h5>
          </CCardHeader>

          <!-- Body -->
          <CCardBody class="pl-0">
            <AccessChart
              id="chart-publications"
              color="#1ed3f2"
              :data="charts.publications"
              :rotate="false"
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
// Components
import CardInfo from '@/components/ui/CardInfo'
import AccessChart from '@/components/ui/Dashboard/AccessChart'

// Getters
import { mapGetters } from 'vuex'

import Service from '@/services/dashboard.service'

export default {
  metaInfo: {
    title: 'Dashboard',
    titleTemplate: ' %s - Manager - Intelli'
  },

  components: {
    CardInfo,
    AccessChart
  },

  data() {
    return {
      cards: [
        {
          label: 'Produtos',
          subLabel: '0',
          color: 'purple',
          image: require('@/assets/img/dashboard/product.png')
        },
        {
          label: 'Aplicações',
          subLabel: '0',
          color: 'blue',
          image: require('@/assets/img/dashboard/application.png')
        },
        {
          label: 'Publicações',
          subLabel: '0',
          color: 'light-blue',
          image: require('@/assets/img/dashboard/publication.png')
        }
      ],

      charts: {
        products: [],
        applications: [],
        publications: []
      }
    }
  },

  computed: {
    ...mapGetters('auth', {
      user: 'user'
    })
  },

  created() {
    this.getDashboard()
  },

  methods: {
    async getDashboard() {
      const response = await Service.index()
      this.cards[0].subLabel = response.totals.products
      this.cards[1].subLabel = response.totals.applications
      this.cards[2].subLabel = response.totals.publications

      this.charts.products = response.info.products.map(product => {
        return {
          ...product,
          id: `#${product.id}`
        }
      })

      this.charts.applications = response.info.applications.map(application => {
        return {
          ...application,
          id: `#${application.id}`
        }
      })

      this.charts.publications = response.info.publications.map(publication => {
        return {
          ...publication,
          id: `#${publication.id}`
        }
      })
    }
  }
}
</script>

<style lang="scss">
#dashboard {
  .cards-container {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .datatable {
    .table {
      margin-bottom: 0;
    }
  }
}
</style>
